export default __webpack_public_path__ + "static/media/plastics.732b4556.jpg";